module.exports = __webpack_public_path__ + "static/media/bkg_2.8ecbfe8e.jpg";